export default __webpack_public_path__ + "static/slide-5-5392bd167ea053126f6877918495e0bc.png";